import { csatAdminQueryKeys as e } from "./useCsatAdminQueryKeys.mjs";
import { useInfiniteListQuery as t, useQuery as n } from "@maat/store-hooks";
import { csatApi as r } from "@maat/api-csat";
//#region src/admin/useCsatAdminQueries.ts
var i = (t) => n({
	queryKey: e.summary(t),
	queryFn: () => r.adminGetSummary(t)
}), a = (t = 12, i) => n({
	queryKey: e.timeseries(t, i),
	queryFn: () => r.adminGetTimeseries({
		months: t,
		feature: i
	})
}), o = (t, i) => n({
	queryKey: e.reasons(t, i),
	queryFn: () => r.adminGetReasons({
		months: t,
		feature: i
	})
}), s = (n = {}) => t({
	queryKey: e.responses(n),
	fetchPage: (e) => r.adminListResponses({
		page: e,
		pageSize: 25,
		...n
	}),
	key: "items"
});
//#endregion
export { o as useCsatAdminReasonsQuery, s as useCsatAdminResponsesQuery, i as useCsatAdminSummaryQuery, a as useCsatAdminTimeseriesQuery };
